import React from 'react'
import styled from 'styled-components'
import { Wrapper } from '@farewill/ui'
import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'
import { BREAKPOINT, COLOR } from '@farewill/ui/tokens'

const StyledLockupWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 22px;
`

const LogoTextSvg = '/images/logos/logo-text.svg'

const StyledLogo = styled.img`
  height: 32px;
  color: ${COLOR.BLACK};

  @media (min-width: ${BREAKPOINT.S}px) {
    height: 38px;
  }
`

const StyledCRUK = styled.img`
  height: 50px;

  @media (min-width: ${BREAKPOINT.S}px) {
    height: 55px;
  }
`
const CancerResearchxFarewill = () => (
  <StyledLockupWrapper noTrim>
    <a aria-label="Visit Farewill's homepage" href="https://farewill.com">
      <StyledLogo alt="Farewill" src={LogoTextSvg} />
    </a>
    <a
      aria-label="Visit Cancer Research UK homepage"
      href="https://www.cancerresearchuk.org/"
    >
      <StyledCRUK
        alt="Cancer research UK Home"
        src={`${CLOUDINARY_ROOT_PATH}/h_150,c_fit,f_auto,q_auto/cobranding-partner-logos/cancer-research-uk/cancer-research-in-partnership_rwyof0.png`}
      />
    </a>
  </StyledLockupWrapper>
)

export default CancerResearchxFarewill
